// src/components/CustomerView/sections/LegalPersonView.tsx
import React from 'react';
import InfoField from '../../../Shared/InfoField';
import { ICustomerDetail } from '../../../../types/customer/customerInterfaces';
import DocumentIdentificationField from '../fields/DocumentIdentificationField';

interface Props {
  detail: ICustomerDetail;
}

const LegalPersonView: React.FC<Props> = ({ detail }) => {
  return (
    <>
      {/* Datos Legales */}
      <section className="mb-8">
        <h3 className="text-gray-700 mb-4 text-lg font-semibold dark:text-white">
          Datos Legales
        </h3>
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          <InfoField label="Razón Social" value={detail.legalName} />
          <InfoField label="Nombre Comercial" value={detail.tradeName} />
          <DocumentIdentificationField detail={detail} />
          <InfoField label="NRC" value={detail.nrc} />
          <InfoField label="Teléfono" value={detail.phone} />
          <InfoField label="Correo" value={detail.email} />
        </div>
      </section>

      {/* Clasificación */}
      <section className="mb-8">
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
          <InfoField
            label="Categoría Contribuyente"
            value={detail.taxpayerCategoryName}
          />
          <InfoField
            label="Tipo de Documento Identificación"
            value={detail.documentIdentificationTypeName}
          />
          <InfoField
            label="Actividad Económica"
            value={detail.economicActivityName}
          />
        </div>
      </section>

      {/* Dirección */}
      <section>
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
          <InfoField label="País" value={detail.countryName} />
          <InfoField label="Departamento" value={detail.departmentName} />
          <InfoField label="Municipio" value={detail.municipalityName} />
        </div>
        <div className="mt-4">
          <InfoField label="Complemento" value={detail.complement} />
        </div>
      </section>
    </>
  );
};

export default LegalPersonView;
